module.exports = __webpack_public_path__ + "ab799f7c7521714b151ba12ca0cbd5c0.png";